/* eslint-disable max-lines */
import { numberPercent } from '@/modules/mdm/utils/regList.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import _ from 'lodash';
import store from '@/store';
const { user } = store.getters;
const EDIT_TYPE = {
    EDIT: 2,
    CANCEL: -3
};

export const config = {
    name: 'revenueFactor',
    searchFields: [
        {
            name: '系数类型',
            value: 'coefType',
            type: 'select',
            optionNum: 'CRM_COEFFICIENT_TYPE',
            isFixed: true,
            span: 4
        },
        {
            name: '分类',
            value: 'coefCategory',
            type: 'select',
            options: [],
            // multiple: true,
            props: {
                // multiple: true,
                value: 'industryCode',
                label: 'industryName'
            },
            isFixed: true,
            span: 4
        },
        {
            name: '年份',
            value: 'coefYears',
            type: 'date',
            timeType: 'years',
            format: 'yyyy',
            valueFormat: 'yyyy',
            isFixed: true,
            span: 4
        },
        {
            name: '创建日期',
            value: 'createTimeFixed',
            type: 'time',
            time: 'daterange',
            format: 'yyyy-MM-dd',
            startPlaceholder: '创建日期从',
            endPlaceholder: '创建日期到',
            isFixed: true,
            span: 8
        }
    ],
    selection: false,
    index: false,
    columns: [
        {
            label: '系数类型',
            prop: 'coefType',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'CRM_COEFFICIENT_TYPE',
            mustFill: true,
            fixed: 'left',
            width: 110
        },
        {
            label: '大类',
            prop: 'category',
            fixed: 'left',
            width: 80
        },
        {
            label: '分类',
            prop: 'coefCategory',
            type: 'slot',
            slot: true,
            editSlot: true,
            mustFill: true,
            fixed: 'left',
            width: 115
        },
        {
            label: '年份',
            prop: 'coefYear',
            type: 'slot',
            editSlot: true,
            mustFill: true,
            fixed: 'left',
            width: 116
        },
        {
            label: '1月系数',
            prop: 'coefForecast1m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '2月系数',
            prop: 'coefForecast2m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '3月系数',
            prop: 'coefForecast3m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '4月系数',
            prop: 'coefForecast4m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '5月系数',
            prop: 'coefForecast5m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '6月系数',
            prop: 'coefForecast6m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '7月系数',
            prop: 'coefForecast7m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '8月系数',
            prop: 'coefForecast8m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '9月系数',
            prop: 'coefForecast9m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '10月系数',
            prop: 'coefForecast10m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '11月系数',
            prop: 'coefForecast11m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '12月系数',
            prop: 'coefForecast12m',
            type: 'input',
            slot: true,
            verify: numberPercent,
            mustFill: true,
            width: 105
        },
        {
            label: '所有人',
            prop: 'ownerName',
            value: 'ownerName',
            name: '添加所有人',
            type: 'advance',
            mustFill: true,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/crmUser/page',
            cbParams: ['esusUserNameCn#ownerName', 'esusLoginName#ownerCode'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            width: 130
        },
        {
            label: '状态',
            prop: 'coefStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'CRM_COEFFICIENT_STATUS',
            width: 80
        },
        {
            label: '修改人',
            prop: 'updateUserName',
            width: 80
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            width: 150
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 100, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '启用',
                event: 'enable',
                displayRule: (row) => {
                    const isAuth = otherUtils.getHasAuth(btnAuthority.revenueFactor.enable);
                    return +row.edit === EDIT_TYPE.CANCEL && +row.coefStatus === 1 && isAuth;
                }
            },
            {
                label: '停用',
                event: 'disable',
                displayRule: (row) => {
                    const isAuth = otherUtils.getHasAuth(btnAuthority.revenueFactor.disable);
                    return +row.edit === EDIT_TYPE.CANCEL && +row.coefStatus === 0 && isAuth;
                }
            }
        ]
    },
    rowEdit: otherUtils.getHasAuth(btnAuthority.revenueFactor.save),
    getAuthRole: () => otherUtils.getHasAuth(btnAuthority.revenueFactor.edit),
    rowEnableEditFun: (row, dictDatas) => { // 是否可编辑（编辑按钮和双击编辑）
        // 判断是否为特权人
        const userList = _.get(dictDatas, 'LCRM_PRIVILEGED_ROLE_LIST.REVENUE_FORECAST_USERS')?.split(',') || [];
        const privilegeAuth = userList.includes(user.userCode);

        const isAuth = otherUtils.getHasAuth(btnAuthority.revenueFactor.edit);

        return isAuth && +row.coefStatus === 0 && (privilegeAuth || user.userCode === row.ownerCode);
    }
};
